import Vue from "vue";
import Vuetify from "vuetify";

// Translation provided by Vuetify (javascript)
import { ko } from "vuetify/src/locale";

// VCurrencyField
import VCurrencyField from "v-currency-field";
Vue.use(VCurrencyField, {
    locale: "kr-KR",
    decimalLength: 0,
    autoDecimalMode: false,
    defaultValue: 0,
    min: null,
    max: null,
    valueAsInteger: false,
    allowNegative: true,
});

Vue.use(Vuetify);

export const basicTheme = {
    breakpoint: {
        thresholds: {
            xs: 576,
            sm: 768,
            md: 1024,
            lg: 1200,
        },
    },
    themes: {
        light: {
            primary: {
                base: "#310FA1",
                darken1: "#2C0D99",
                darken2: "#250B8F",
                darken3: "#1F0885",
                darken4: "#130474",
                lighten1: "#5033AF",
                lighten2: "#6F57BD",
                lighten3: "#9887D0",
                lighten4: "#C1B7E3",
                lighten5: "#E6E2F4",
            },
            secondary: {
                base: "#ED2B71",
                darken1: "#EB2669",
                darken2: "#E8205E",
                darken3: "#E51A54",
                darken4: "#E01042",
                lighten1: "#F04B86",
                lighten2: "#F26B9C",
                lighten3: "#F695B8",
                lighten4: "#FABFD4",
                lighten5: "#FDE6EE",
            },
            accent: "#310fa1",
            error: "#ff0000",
            info: "#2196F3",
            success: "#4CAF50",
            warning: "#FFC107",
            anchor: "inherit",
            grey: "#666",
            "grey-b3": "#b3b3b3",
            "grey-c": "#ccc",
            "grey-d": "#ddd",
            "grey-3": "#333",
            "grey-5f": "#5f5f5f",
            "grey-6": "#666",
            "grey-9": "#999",
            "grey-13": "#131313",
            "grey-f5": "#f5f5f5",
            "grey-f7": "#F7F6F8",
            "grey-f8": "#f8f9fb",
            "grey-f1": "#f1f2f6",
            "grey-eb": "#ebecf2",
            "grey-ec": "#ececec",
            "u-green": "#0f98a1",
            "u-yellow": "#ffe810",
            "u-yellow-dark": "#cba04d",
            "u-pink": "#e26262",
            "u-green-5a": "#5AB72E",
            "u-green-e7": "#E7FCE4",
            lightblue: {
                base: "#1DACE3",
                darken1: "#1AA5E0",
                darken2: "#159BDC",
                darken3: "#1192D8",
                darken4: "#0A82D0",
                lighten1: "#3FB8E7",
                lighten2: "#61C5EB",
                lighten3: "#8ED6F1",
                lighten4: "#BBE6F7",
                lighten5: "#E4F5FC",
            },
            green: {
                base: "#548662",
            },
            kakao: "#FAE100",
            "kakao-marker":"#007DFF"
        },
        // dark: {
        //     primary: colors.purple.base,
        //     secondary: '#424242',
        //     accent: '#82B1FF',
        //     error: '#FF5252',
        //     info: '#2196F3',
        //     success: '#4CAF50',
        //     warning: '#FFC107',
        // }
    },
    options: { customProperties: true },
};

export const consoleTheme = {
    themes: {
        light: {
            primary: "#00C73C",
            secondary: "#445163",
            accent: "#00C73C",
            // error: '#FF5252',
            info: "#2D3539",
            content: "#EDF0F5",
            // success: '#4CAF50',
            // warning: '#FFC107',
            anchor: "#333",
        },
        // dark: {
        //     primary: colors.purple.base,
        //     secondary: '#424242',
        //     accent: '#82B1FF',
        //     error: '#FF5252',
        //     info: '#2196F3',
        //     success: '#4CAF50',
        //     warning: '#FFC107',
        // }
    },
    options: { customProperties: true },
};

export const developerTheme = {
    themes: {
        light: {
            primary: "#82B1FF",
            secondary: "#243143",
            accent: "#00C73C",
            // error: '#FF5252',
            info: "#232631",
            content: "#F0F4FF",
            // success: '#4CAF50',
            // warning: '#FFC107',
            anchor: "#333",
        },
    },
};

/**
 *
 * @param {(basicTheme|consoleTheme)} theme
 * @returns
 */
export default function(theme) {
    return new Vuetify({
        lang: {
            locales: { ko },
            current: "ko",
        },
        theme: theme || basicTheme,
    });
}
